"use strict";function setMenu$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.setMenu$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiHelper_1=require("../../../lib/apiHelper"),apiName="biz.navigation.setMenu";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.6.0",paramsDeal:apiHelper_1.addWatchParamsDeal},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.6.0",paramsDeal:apiHelper_1.addWatchParamsDeal},_a)),exports.setMenu$=setMenu$,exports.default=setMenu$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/navigation/setMenu.js
// module id = 977
// module chunks = 106